import { useMutation } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { QuestionnaireExportApi } from '../../../apis/QuestionnaireExportApi/QuestionnaireExportApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { downloadBlob } from '../../../helpers/downloadBlob';

export function useDownloadQuestionnaireExport() {
    const { t } = useTranslation();

    return useMutation<Blob, AppMedError, { healthcareFacilityId: number; password: string }>({
        mutationKey: [QueryKeys.questionnaires, 'downloadExport'],
        mutationFn: async ({ healthcareFacilityId, password }) => {
            return await QuestionnaireExportApi.downloadZip(healthcareFacilityId, password);
        },
        onSuccess: (blob, { healthcareFacilityId }) => {
            const filename = `QuestionnaireExport_Facility${healthcareFacilityId}_${new Date().toISOString().split('T')[0]}.zip`;
            downloadBlob(blob, filename);

            notifications.show({
                title: t('questionnaireExport.notifications.downloadSuccess.title'),
                message: t('questionnaireExport.notifications.downloadSuccess.message'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('questionnaireExport.notifications.downloadError.title'),
                message: error?.message || t('questionnaireExport.notifications.downloadError.message'),
                color: 'red',
            });
        },
    });
}
